import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import OrderReturnManagementContainer from '../../containers/order/OrderReturnManagementContainer';
import { ORDER_PAGE_NAME } from '../../constants/service/app/orderConstants';

const OrderReturnManagement = () => {
  return (
    <PageTemplate pageName={ORDER_PAGE_NAME.ORDER_RETURN_MANAGEMENT}>
      <OrderReturnManagementContainer />
    </PageTemplate>
  );
};

export default OrderReturnManagement;
